import { usePromoContext } from 'fitify-ui-onboarding/src/contexts/PromoContext'
import { usePaddle } from 'fitify-ui-onboarding/src/hooks/subscription/usePaddle'
import { useSubscriptionConfig } from 'fitify-ui-onboarding/src/hooks/subscription/useSubscriptionConfig'
import { useEffect } from 'react'

import { PADDLE_CREDENTIALS } from 'utils/paddle'
import { useDataState } from 'utils/state'

export const FetchDiscountForDiscountReveal = () => {
  const { promoCode } = usePromoContext()
  const { data, set } = useDataState()

  const { pageConfig, subscriptionPlanConfigs } = useSubscriptionConfig({
    promoCode,
    defaults: { pageConfig: { defaultPeriod: 'longest' } },
  })

  const { plans } = usePaddle({
    cacheKey: '@fitify/subscription/paddlePlans',
    discountId: pageConfig.paddleDiscountId,
    paddleCredentials: PADDLE_CREDENTIALS,
    planConfigs: subscriptionPlanConfigs,
  })

  useEffect(() => {
    if (plans.length > 0) {
      const firstPlan = plans[0]
      set('common', {
        discount_reveal_state: {
          ...(data.common.discount_reveal_state || {}),
          discountPercentageValue: firstPlan.discountPercentValue,
        },
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [plans])

  return null
}
